import type { DimensionPrecision } from "building-types/views/viewTypes";
import { formatWithPrecision } from "doc/dimensions";
import { formatInchesRounded } from "doc/measurementUtils";

export function formatDimText(props: {
  dimensionPrecision?: DimensionPrecision;
  prefix?: string;
  suffix?: string;
  dimVal?: number;
}): string {
  if (props.dimVal === undefined) {
    return "";
  }

  const prefix = props.prefix ?? "";
  const suffix = props.suffix ?? "";
  const formattedValue = props.dimensionPrecision
    ? formatWithPrecision(props.dimVal, props.dimensionPrecision)
    : formatInchesRounded(props.dimVal);

  return `${prefix}${formattedValue}${suffix}`;
}
